import type { ReactNode } from "react";
import { PageHeader } from "@/components/page-header";
import styles from "./list-workspace.module.css";

export function ListWorkspace({
  eyebrow,
  title,
  description = "",
  actions,
  feedback,
  children,
  className = "",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  feedback?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <main className={`page ${styles.workspace} ${className}`.trim()}>
      <PageHeader
        eyebrow={eyebrow}
        title={title}
        description={description}
        actions={actions}
      />
      {feedback ? <div className={styles.feedback}>{feedback}</div> : null}
      <div className={styles.content}>{children}</div>
    </main>
  );
}
